<template>
  <!-- 首页 -->
  <div class="container">
    <div class="containerWrap">
      <div class="topLogo">
        <div class="topLogoMain">
          <div class="topLogoMainLeft">
            <router-link to="/">
              <img src="../assets/images/top/logo.png" class="Nlogo" />
            </router-link>
          </div>
          <div class="topLogoMainRight">
            <!-- <div class="addsc" style="float: right">
              <a href="" class="a1">设为首页</a>
              <a href="" class="a2">添加收藏</a>
            </div> -->
            <div class="header_search">
              <div>
                <input
                  type="text"
                  v-model="searchValue"
                  name="KeyWord"
                  required="required"
                  placeholder="请输入关键字"
                  class="form-control"
                  style="float: left"
                />
                <el-button
                  type="submit"
                  class="btn"
                  @click="handleSearch"
                  style="
                    float: left;
                    background-color: #ffffff;
                    border-radius: 0px;
                  "
                  ><i class="iconfont">&#xe782; </i>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="topMenu">
        <div class="topMenuMain">
          <div class="nav_box">
            <ul class="menuUL">
              <li class="menuLi">
                <div class="nav_grop">
                  <div
                    style="
                      width: 25px;
                      height: 25px;
                      float: left;
                      margin-left: 15px;
                      margin-top: 15px;
                    "
                  >
                    <img src="../assets/images/top/1.png" alt="" />
                  </div>
                  <h2 style="display: inline-block">
                    <router-link to="/">网站首页</router-link>
                  </h2>
                  <span class="span1"></span>
                </div>
              </li>
              <li v-for="(item, index) in navList" :key="index" class="menuLi">
                <div
                  class="nav_grop"
                  @mouseenter="navShow(item.channelId)"
                  @mouseleave="navClose()"
                >
                  <div
                    style="
                      float: left;
                      width: 25px;
                      height: 25px;
                      margin-left: 15px;
                      margin-top: 15px;
                    "
                    :class="'ContentList' + index"
                  >
                    <!-- <img src="navList1" style="width: 20px;height: 50px;" /> -->
                  </div>
                  <h2>
                    <a
                      v-if="
                        item.child.length &&
                        item.child[0].url &&
                        item.child[0].url !== ''
                      "
                      target="_blank"
                      :href="item.url"
                    >
                      {{ item.name }}
                    </a>
                    <a
                      v-if="
                        item.child.length &&
                        (!item.child[0].url || item.child[0].url == '')
                      "
                      :href="
                        item.catalog == 1
                          ? `/listPage/${item.child[0].entTChannelUuid}`
                          : item.catalog == 2
                          ? `/list/${item.child[0].entTChannelUuid}`
                          : `/listPic/${item.child[0].entTChannelUuid}`
                      "
                    >
                      {{ item.name }}
                    </a>
                    <a
                      v-if="!item.child.length"
                      :href="
                        item.catalog == 1
                          ? `/listPage/${item.entTChannelUuid}`
                          : item.catalog == 2
                          ? `/list/${item.entTChannelUuid}`
                          : `/listPic/${item.entTChannelUuid}`
                      "
                    >
                      {{ item.name }}
                    </a>
                  </h2>

                  <el-collapse-transition>
                    <div class="nav_down" v-show="navDown == item.channelId">
                      <div
                        class="transition-box"
                        v-show="item.child.length != 0"
                      >
                        <p
                          v-for="(item1, index1) in item.child"
                          :key="index1"
                          class="transitLI"
                        >
                          <a
                            v-if="
                              item1.child.length &&
                              item1.child[0].url &&
                              item1.child[0].url !== ''
                            "
                            target="_blank"
                            :href="item1.url"
                          >
                            {{ item1.name }}
                          </a>
                          <a
                            v-if="
                              item1.child.length &&
                              (!item1.child[0].url || item1.child[0].url == '')
                            "
                            :href="
                              item1.catalog === 1
                                ? `/listPage/${item1.child[0].entTChannelUuid}`
                                : item1.catalog === 2
                                ? `/list/${item1.child[0].entTChannelUuid}`
                                : `/listPic/${item1.child[0].entTChannelUuid}`
                            "
                          >
                            {{ item1.name }}
                          </a>
                          <a
                            v-if="!item1.child.length"
                            :href="
                              item1.catalog == 1
                                ? `/listPage/${item1.entTChannelUuid}`
                                : item1.catalog == 2
                                ? `/list/${item1.entTChannelUuid}`
                                : `/listPic/${item1.entTChannelUuid}`
                            "
                          >
                            {{ item1.name }}
                          </a>
                        </p>
                      </div>
                    </div>
                  </el-collapse-transition>
                  <span class="span1" v-if="index < navList1.length - 1"></span>
                  <span class="span2"></span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="main" style="background-color: #fff">
        <router-view></router-view>
      </div>
      <div style="clear: both"></div>
      <div class="footer">
        <div class="innerCon">
          <div class="l_con">
            <p style="margin-top: 5px">
              版权所有：甘肃第九建设集团有限责任公司
            </p>
            <p style="margin-top: 5px">地址：甘肃省武威市凉州区南关中路169号</p>
            <p style="margin-top: 5px">电话：0935-6181043</p>
            <p style="margin-top: 5px">邮箱：gs9jian@163.com</p>
            <p style="margin-top: 5px">
              <a
                href="https://beian.miit.gov.cn/"
                style="color: white; font-size: 14px"
                target="_blank"
                >备案号：陇ICP备18001801号-2</a
              >
            </p>
          </div>
          <div class="r_con">
            <img src="../assets/images/blogo.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNavChannel } from "@/api/common";

export default {
  name: "",
  data() {
    return {
      searchValue: "",
      active: 0,
      navList: [],
      navList1: [
        {
          name: "集团新闻",
          catalog: "2",
          child: [],
        },
        {
          name: "建投要闻",
          child: [],
        },
        {
          name: "企业文化",
          child: [],
        },
        {
          name: "科技创新",
          child: [],
        },
        {
          name: "党建工作",
          child: [],
        },
        {
          name: "消防专栏",
          child: [],
        },
        {
          name: "联系方式",
          child: [],
        },
      ],
      navDown: 0,
    };
  },
  mounted() {
    this.getPath();
    this.getNavChannel();
  },
  created() {},
  watch: {
    $route: "getPath",
  },
  methods: {
    // 获取导航
    getNavChannel() {
      var _this = this;
      let data = {
        applicationUuid: _this.webId,
      };
      getNavChannel(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.navList = data.slice(0, 6);
        }
      });
    },
    handleSearch() {
      var _this = this;
      if (!_this.searchValue || _this.searchValue == "") {
        this.$message({
          message: "请输入关键词",
          type: "warning",
        });
      } else {
        window.location.href = `/search/${_this.searchValue}`;
      }
    },
    // 二级导航展开
    navShow(d) {
      let _this = this;
      // _this[d] = true
      _this.navDown = d;
    },
    // 二级导航收起
    navClose() {
      let _this = this;
      // _this[d] = false
      _this.navDown = 0;
    },
    haddleNav(index, params) {
      var _this = this;

      _this.active = index;
      _this.$router.push(params.url);
    },
    getPath() {
      var _this = this;
      _this.active = _this.$route.meta.index;
    },
  },
};
</script>

<style>
@font-face {
  font-family: "iconfont"; /* Project id 3165120 */
  src: url("//at.alicdn.com/t/font_3165120_76d7pwtenjr.woff2?t=1645689140903")
      format("woff2"),
    url("//at.alicdn.com/t/font_3165120_76d7pwtenjr.woff?t=1645689140903")
      format("woff"),
    url("//at.alicdn.com/t/font_3165120_76d7pwtenjr.ttf?t=1645689140903")
      format("truetype");
}

@font-face {
  font-family: "iconfont"; /* project id 3165259 */
  src: url("");
  src: url("?#iefix") format("embedded-opentype"),
    url("//at.alicdn.com/t/font_3165259_4zwhtyd54xp.woff2") format("woff2"),
    url("//at.alicdn.com/t/font_3165259_4zwhtyd54xp.woff") format("woff"),
    url("//at.alicdn.com/t/font_3165259_4zwhtyd54xp.ttf") format("truetype"),
    url("#iconfont") format("svg");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

.topLogo {
  overflow: hidden;
  padding: 0px 0px;
  background: url(../assets/img/TopLine.jpg);
}
.topLogoMain {
  width: 1200px;
  height: 169px;
  overflow: hidden;
  margin: 0 auto;
}
.topLogoMainLeft {
  width: 710px;
  overflow: hidden;
  margin-top: 39px;
  margin-bottom: 12px;
}
.topLogoMainLeft {
  float: left !important;
}
.topLogoMainRight {
  width: 380px;
  height: 110px;
  margin-top: 30px;
  overflow: hidden;
}
.topLogoMainRight {
  float: right !important;
}
.header_search {
  width: 380px;
  height: 51px;
  overflow: hidden;
  float: right;
  position: relative;
  margin-top: 27px;
}
.header_search input {
  width: 280px;
  height: 34px;
  overflow: hidden;
  outline: none;
  box-shadow: none;
  line-height: 352px;
  font-size: 14px;
  color: #585858;
  border-radius: 0px;
  border: solid 1px #e6e6e6;
  background-color: #fff;
}

.addsc .a1 {
  background: url(../assets/img/sc2.png) left center no-repeat;
}
.addsc .a2 {
  background: url(../assets/img/sc1.png) left center no-repeat;
}
.addsc a {
  color: #a6a6a6;
  width: 70px;
  float: left;
  margin-right: 15px;
  text-align: right;
  font-size: 12px;
  height: 30px;
  line-height: 33px;
  display: block;
}

.form-control {
  display: block;
  padding: 6px 12px;
}
.btn {
  display: inline-block;
  height: 48px;
  width: 48px;
  line-height: 38px;
  padding: 0px 12px;
  color: #1c1c1c;
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  border: none;
  border: solid 1px #e6e6e6;
  cursor: pointer;
}
.topMenu {
  height: 50px;
  background-color: #0062b3;
  overflow: hidden;
  border-bottom: 1px #ffffff solid;
}
.topMenuMain {
  width: 100%;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
  text-align: center;
}
.topMenuMain .menuUL {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
}
.topMenuMain .menuUL .menuLi {
  position: relative;
  width: 168px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  float: left;
  color: #ffffff;
  display: block;
  font-size: 16px;
  z-index: 22;
  margin-left: 2px;
}
.topMenuMain .menuUL li:hover {
  background-color: rgba(7, 6, 63, 0.425) !important;
}
.topMenuMain .menuLi a {
  font-family: "微软雅黑", "Microsoft YaHei", sans-serif;
  font-size: 16px;
  color: #ffffff;
  margin-left: -22px;
}
.span1 {
  width: 2px;
  height: 50px;
  border-left: 1px #a4bacf solid;
  display: inline-block;
  position: absolute;
  right: 0;
  top: 0;
  margin-right: -4px;
}
.span2 {
  width: 2px;
  height: 50px;
  display: inline-block;
}
.topMenuMain .menuLi a {
  font-family: "微软雅黑", "Microsoft YaHei", sans-serif;
  font-size: 16px;
  color: #ffffff;
  display: block;
  height: 50px;
  line-height: 50px;
  margin-left: -25px;
}
.transition-box .transitLI {
  background-color: #0062b3;
  border-top: 1px solid #99a5b1;
}
.transition-box .transitLI a {
  width: 169px;
  height: 35px;
  line-height: 35px;
  display: block;
  color: #ffffff;
  font-weight: normal;
  font-size: 13px;
}
.transition-box .transitLI a:hover {
  background-color: rgba(7, 6, 63, 0.425) !important;
}

.footMain {
  height: auto;
  margin: 0px auto;
  font: 14px Helvetica Neue, Helvetica, PingFang SC, \5fae\8f6f\96c5\9ed1,
    Tahoma, Arial, sans-serif;
}
.linkBg {
  width: 100%;
  background-color: #e7e7e7;
  height: auto;
}
.Tpage {
  width: 1200px;
  margin: 0px auto;
}
.FriendLink {
  height: 32px;
  padding: 22px 0px;
}
.Twpage {
  width: 100%;
  overflow: hidden;
}
.FriendLink select {
  height: 32px;
  width: 238px;
}

a,
a:focus,
a:hover {
  text-decoration: none;
}
a {
  font-family: "微软雅黑", "Microsoft YaHei", sans-serif;
  font-size: 16px;
  color: #000000;
}
.EndLink {
  width: 100%;
  background-color: #004a87;
  padding: 30px 0px;
  color: #ffffff;
}
.EndLink .Left {
  width: 820px;
  float: left;
  overflow: hidden;
}
.EndLink .Left .tit {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
}
.EndLink .Left li {
  width: 116px;
  float: left;
  /* overflow: hidden; */
  line-height: 30px;
  font-size: 12px;
  text-align: center;
}

.EndLink .Left .big_li2 {
  width: 168px;
  font-size: 13px;
  text-align: left;
  font-size: 13px;
  font-weight: bolder;
}

li {
  list-style: none;
}
.EndLink .Left li .big {
  height: 35px;
  line-height: 35px;
  font-size: 13px;
  font-weight: bolder;
}
.EndLink .Left li a {
  width: 100%;
  display: block;
  text-align: center;
  color: #ffffff;
}
.EndLink .Left li .small {
  height: 22px;
  line-height: 22px;
  font-size: 12px;
  color: #a5c1d7;
}

.EndLink .Center {
  width: 172px;
  float: left;
  margin-left: 20px;
  overflow: hidden;
}
.EndLink .Center .tit {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  margin-bottom: 8px;
}
.EndLink .Center b {
  font-size: 13px;
}
.EndLink .Center span {
  color: #fff004;
  font-size: 26px;
  padding: 0px 0px 10px 0px;
  display: block;
  width: 100%;
}

.EndLink .Center p {
  color: #ffffff;
  line-height: 22px;
  font-size: 12px;
}
.EndLink .Right {
  width: 150px;
  float: right;
  text-align: center;
  line-height: 40px;
}
.EndLink .Right img {
  width: 105px;
  height: 105px;
  margin-top: 5px;
}
img {
  display: inline-block;
  border: none;
}
.footer {
  height: 170px;
  background: #0062b2;
}
.innerCon {
  width: 1200px;
  margin: 0 auto;
  height: 170px;
}
.l_con {
  width: 50%;
  float: left;
  color: white;
  margin-top: 25px;
}
.r_con {
  background: #0062b2;
  /* width: 50%; */
  float: right;
  /* height: 170px; */
  margin-top: 25px;
}
.main {
  height: auto;
}
.Foot {
  width: 100%;
  overflow: hidden;
  line-height: 25px;
  padding: 20px 0px;
  background-color: #004a87;
  text-align: center;
  color: #a4c0d5;
  border-top: 1px #6284a0 solid;
}
.Foot a {
  color: #a4c0d5;
  font: 14px Helvetica Neue, Helvetica, PingFang SC, \5fae\8f6f\96c5\9ed1,
    Tahoma, Arial, sans-serif;
  /* 首页导航栏背景图片 */
}
.ContentList0 {
  background-image: url(../assets/images/top/2.png);
  background-repeat: no-repeat;
}
.ContentList1 {
  background-image: url(../assets/images/top/6.png);
  background-repeat: no-repeat;
}
.ContentList2 {
  background-image: url(../assets/images/top/3.png);
  background-repeat: no-repeat;
}
.ContentList3 {
  background-image: url(../assets/images/top/5.png);
  background-repeat: no-repeat;
}
.ContentList4 {
  background-image: url(../assets/images/top/4.png);
  background-repeat: no-repeat;
}
.ContentList5 {
  background-image: url(../assets/images/top/8.png);
  background-repeat: no-repeat;
}
.ContentList6 {
  background-image: url(../assets/images/top/7.png);
  background-repeat: no-repeat;
}
</style>
